import React, { useRef } from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

// Text input/textarea with an "Insert merge field" picker that inserts at the cursor
export const MergeFieldTextInput = ({ label, value, onChange, mergeFields, multiline, rows = 4, placeholder, disabled, testId, footer }) => {
  const ref = useRef(null);

  const insert = (field) => {
    const el = ref.current;
    const current = value || '';
    const start = el?.selectionStart ?? current.length;
    const end = el?.selectionEnd ?? current.length;
    onChange(current.slice(0, start) + field + current.slice(end));
    requestAnimationFrame(() => {
      if (!el) return;
      el.focus();
      el.setSelectionRange(start + field.length, start + field.length);
    });
  };

  const Field = multiline ? Textarea : Input;

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between gap-2">
        <Label className="text-xs">{label}</Label>
        {!disabled && (
          <Select value="" onValueChange={insert}>
            <SelectTrigger className="w-44 h-7 text-xs" data-testid={`${testId}-merge-field-select`}>
              <SelectValue placeholder="Insert merge field" />
            </SelectTrigger>
            <SelectContent className="max-h-80">
              {mergeFields.map((mf) => (
                <SelectItem key={mf.field} value={mf.field} className="text-xs">
                  <span className="font-mono">{mf.field}</span>
                  {mf.description && <span className="text-muted-foreground ml-2">{mf.description.slice(0, 50)}</span>}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </div>
      <Field
        ref={ref}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        rows={multiline ? rows : undefined}
        placeholder={placeholder}
        disabled={disabled}
        className="font-mono text-sm"
        data-testid={testId}
      />
      {footer}
    </div>
  );
};
